function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.87139 4.77633C6.44935 4.25245 6.49639 3.3604 5.97672 2.77864L4.55698 1.36167C3.97558 0.840988 3.08269 0.888067 2.55927 1.467L1.6946 2.33074C0.953493 3.02147 0.785076 4.13133 1.28791 5.01082C3.50837 8.51985 6.48048 11.4919 9.98956 13.7124C10.8687 14.2146 11.9778 14.0466 12.6688 13.3066L13.5334 12.4419C14.1122 11.9179 14.1589 11.0248 13.6378 10.4433L12.219 9.02452C11.6378 8.50473 10.746 8.55136 10.2222 9.12894L9.69554 9.65469C8.09332 8.36372 6.63493 6.90381 5.34563 5.30026L5.87139 4.77633Z",
  stroke: "#96A8BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.8c2bf1b9.svg";
export { ForwardRef as ReactComponent };